import React from 'react';
import { I18nextProvider } from 'react-i18next';
import az from './locales/az.json';
import ru from './locales/ru.json';

document.addEventListener('DOMContentLoaded', async () => {
  const container: HTMLElement | null = document.getElementById('chat-write-link');

  if (!container) return;

  container.style.width = '100%';

  try {
    const { createRoot } = await import('react-dom/client');
    const { WriteMessageLink } = await import('./components');
    const { customizeI18n } = await import('../utils/i18n');
    const { ThemeProviderWrapper } =
      await import('@/styled/themes/ThemeProvider/ThemeProviderWrapper');

    const isUserSignedIn = container.dataset.userSignedIn === 'true';
    const isMobile = container.dataset.isMobile === 'true';
    const listing = JSON.parse(container.dataset.listing || '');
    const receiver = JSON.parse(container.dataset.receiver || '');
    const userDigitUid = JSON.parse(container.dataset.user);

    receiver.id = userDigitUid;
    const i18n = customizeI18n({ az, ru });

    createRoot(container).render(
      <I18nextProvider {...{ i18n }}>
        <ThemeProviderWrapper>
          <WriteMessageLink
            {...{ isUserSignedIn, listing, receiver, isMobile }}
            backgroundColor="#4c88f9"
          />
        </ThemeProviderWrapper>
      </I18nextProvider>
    );
  } catch (e) {
    console.error('Failed while initializing chat-write-link', e);
  }
});
